import i18n from '../../language/index'
import linkData from '@/base/linkData'

export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    customFont: {
      name: '',
      url: ''
    },
    lineHeight: i18n.t('view_back_top_edit_103'),
    fontSize: 20,
    fsWeight: 'normal',
    fsItalics: 'normal',
    fontStyle: '',
    fontUnderline: 'none',
    fontFamily: 'Arial',
    titleColor: 'rgba(51, 51, 51,1)',
    textAlign: 'left',
    background: 'rgba(252, 255, 255,1)',
    pattern: 'pure_color',
    linear_gradient: {
      start_color: "rgba(0,0,0,1)",
      end_color: "rgba(0, 0, 0,1)",
      start_pointer: 0,
      end_pointer: 100,
      deg: 90
    },
    selectValue1: 'default'
  },
  mb_widgets_infor: {},
  listArr: {
    title: '',
    link: linkData
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_text/style.js